<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="markdown-container" v-html="compiledMarkdown"></div>
  <!--eslint-enable-->
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import MarkdownIt from 'markdown-it'
import MarkdownItIns from 'markdown-it-ins'

const props = defineProps({
  source: {
    type: String,
    required: true
  }
})
const md = new MarkdownIt().use(MarkdownItIns)
const compiledMarkdown = computed(() => md.render(props.source))
</script>
